import { CheckSVGIcon } from '@/shared/assets'
import { cn } from '@/true-fsd/shared/utils/css'

const checkColors = {
    green: {
        checked: 'bg-synapex-green',
        unchecked: 'bg-secondary',
    },
    blue: {
        checked: 'bg-blue-primary',
        unchecked: 'bg-secondary',
    },
} as const

export const CheckIcon: React.FC<{
    className?: string
    checked: boolean
    variant?: keyof typeof checkColors
}> = ({ className, checked, variant = 'green' }) => {
    return (
        <CheckSVGIcon
            className={cn(
                'rounded-full',
                className,
                checked
                    ? checkColors[variant].checked
                    : checkColors[variant].unchecked
            )}
        />
    )
}
